export function Debounce(milliseconds = 100): MethodDecorator {
  return function (
    _target: unknown,
    _propertyKey: string | symbol,
    descriptor: PropertyDescriptor
  ): PropertyDescriptor {
    // eslint-disable-next-line @typescript-eslint/ban-types
    const originalMethod: Function = descriptor.value
    let timer = 0

    descriptor.value = function (...args: Array<unknown>) {
      if (timer) clearTimeout(timer)

      timer = setTimeout(() => {
        originalMethod.apply(this, args)
      }, milliseconds)
    }

    return descriptor
  }
}
